import { useCallback } from 'react';

import { beginCheckout } from 'services/avo';
import { useTrackEvent } from 'services/datalayer/hooks';
import { CartFragment } from 'types/api/tickets.types';

import { useEventBundle } from './useEventBundle';
import { mapCartToDatalayer } from './utils';

export const useTrackBeginCheckout = () => {
  const eventBundle = useEventBundle();

  const track = useTrackEvent({
    trackFn: beginCheckout,
    variables: eventBundle,
  });

  return useCallback(
    (cart: CartFragment) => {
      track(mapCartToDatalayer(cart, eventBundle));
    },
    [eventBundle, track],
  );
};
